"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const custom_cell_1 = require("pages/user-access/user/sub-components/custom-cell");
const react_redux_1 = require("react-redux");
const header_menu_1 = __importDefault(require("components/molecules/header-menu"));
const grid_1 = __importDefault(require("components/templates/grid"));
const store_1 = require("store");
const user_types_1 = require("../user.types");
const user_action_1 = __importDefault(require("../user.action"));
const user_style_1 = __importDefault(require("../user.style"));
const user_mutation_component_1 = __importDefault(require("./user.mutation.component"));
const modal_1 = require("components/molecules/modal");
const modal_reset_1 = __importDefault(require("components/molecules/modal/sub-components/modal-reset"));
const svg_1 = require("components/atoms/svg");
const react_router_dom_1 = require("react-router-dom");
const authorization_1 = require("utils/authorization");
const User = () => {
    const { dataGrid, dataStates, isLoading, isLoadingDetail, isSuccess, dataItem, mutationMode, isError, errorMessage, dataCheckpoint } = (0, store_1.useAppSelector)(state => state.userAccess.userReducer);
    const { appTheme } = (0, store_1.useAppSelector)(state => state.app);
    const { userData } = (0, store_1.useAppSelector)(state => state.auth);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const isAuthorized = (0, authorization_1.userRoleAuth)(userData.authorization, 'User Access', 'User');
    (0, react_1.useEffect)(() => {
        if (isAuthorized.view) {
            if (isLoading)
                dispatch(user_action_1.default.getDataGrid(dataStates));
        }
        else {
            navigate('/dashboard', { replace: true });
        }
    }, [isLoading, isAuthorized]);
    (0, react_1.useEffect)(() => {
        if (isAuthorized.view) {
            if (isLoadingDetail)
                dispatch(user_action_1.default.getCheckpoint());
            if (mutationMode == 'add' || mutationMode == 'edit')
                dispatch(user_action_1.default.getDetail());
        }
        else {
            navigate('/dashboard', { replace: true });
        }
    }, [isLoadingDetail, isAuthorized, mutationMode]);
    const actionCellRender = (0, custom_cell_1.actionCell)([
        {
            type: 'other',
            permission: isAuthorized.change,
            icon: (0, jsx_runtime_1.jsx)(svg_1.EditIcon, { color: appTheme === 'dark' ? '#fff' : '#424242' }),
            onClick: d => dispatch(user_action_1.default.onClickMutation({
                mutationMode: 'edit', dataItem: Object.assign(Object.assign({}, d), { checkpoint: dataCheckpoint === null || dataCheckpoint === void 0 ? void 0 : dataCheckpoint.filter(x => { var _a, _b; return x.id == ((_b = (_a = d.operator_access) === null || _a === void 0 ? void 0 : _a.find(y => (y === null || y === void 0 ? void 0 : y.checkpoint_id) == x.id)) === null || _b === void 0 ? void 0 : _b.checkpoint_id); }), role: {
                        id: d.role_id,
                        name: d.role_name
                    }, department_obj: {
                        id: d.department_id,
                        department_name: d.department
                    }, contractor: {
                        id: d.contractor_id,
                        contractor_name: d.contractor_name
                    }, is_active: {
                        status: d.is_active ? 'Active' : 'Inactive',
                        value: Boolean(d.is_active)
                    }, modified_by: userData.id }), isSuccess: false
            })),
        },
        {
            type: 'other',
            permission: isAuthorized.change,
            icon: (0, jsx_runtime_1.jsx)(svg_1.DeleteIcon, { color: appTheme === 'dark' ? '#fff' : '#424242' }),
            onClick: d => dispatch(user_action_1.default.onClickMutation({ mutationMode: 'delete', dataItem: d, isSuccess: false })),
        },
        {
            type: 'other',
            permission: isAuthorized.change,
            icon: (0, jsx_runtime_1.jsx)(svg_1.ChangePasswordIcon, { color: appTheme === 'dark' ? '#fff' : '#424242' }),
            onClick: d => dispatch(user_action_1.default.onClickMutation({ mutationMode: 'reset', dataItem: d, isSuccess: false })),
        },
    ]);
    const actionColumn = [{
            title: '',
            width: '100px',
            sortable: false,
            filterable: false,
            show: isAuthorized.change,
            cell: actionCellRender,
            locked: true,
        }];
    const onDataStateChange = (types, val) => {
        const newDataStates = Object.assign(Object.assign({}, dataStates), { skip: types === 'page' ? (val - 1) * dataStates.take : 0, take: types === 'take' ? val : dataStates.take });
        dispatch(user_action_1.default.onDataStateChange(newDataStates));
    };
    const onFilterChange = (e) => {
        dispatch(user_action_1.default.onFilterChange(e.filter));
        const newDataStates = Object.assign(Object.assign({}, dataStates), { filter: e.filter });
        dispatch(user_action_1.default.getDataGrid(newDataStates));
    };
    const onSortChange = (e) => {
        dispatch(user_action_1.default.onDataStateChange(Object.assign(Object.assign({}, dataStates), { sort: e.sort })));
    };
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(header_menu_1.default, { title: 'User', theme: appTheme, isLoading: isLoading, isAddNew: isAuthorized.change, onAddNew: () => dispatch(user_action_1.default.onClickMutation({
                    mutationMode: 'add', isSuccess: false, isLoadingSubmit: false
                })) }), (0, jsx_runtime_1.jsx)(modal_1.ModalSuccess, { show: isSuccess, appTheme: appTheme, messageSuccess: 'Data saved Successfully', onClose: () => {
                    dispatch(user_action_1.default.onDataStateChange(dataStates));
                    dispatch(user_action_1.default.onClickMutation({ mutationMode: false, isSuccess: false }));
                } }), (0, jsx_runtime_1.jsx)(modal_1.ModalConfirm, { show: isError && errorMessage === 'username already exist!', appTheme: appTheme, errorSubject: 'Do you want reactive?', errorMessage: errorMessage, onClose: () => {
                    dispatch(user_action_1.default.closeError());
                    dispatch(user_action_1.default.onDataStateChange(dataStates));
                    dispatch(user_action_1.default.onClickMutation({ mutationMode: false, isSuccess: false }));
                }, onConfirm: () => {
                    dispatch(user_action_1.default.closeError());
                    dispatch(user_action_1.default.onReactiveUser({ dataItem, isSuccess: false }));
                    dispatch(user_action_1.default.onClickMutation({ mutationMode: false }));
                }, style: { 'zIndex': 10 } }), (0, jsx_runtime_1.jsx)(modal_reset_1.default, { show: mutationMode === 'reset', appTheme: appTheme, errorSubject: dataItem.username, errorMessage: 'Are you sure to give Reset Password to user', onClose: () => dispatch(user_action_1.default.onClickMutation({ mutationMode: false, isSuccess: false })), onConfirm: () => dispatch(user_action_1.default.onReset({ dataItem, isSuccess: false })) }), (0, jsx_runtime_1.jsx)(user_mutation_component_1.default, {}), (0, jsx_runtime_1.jsx)(grid_1.default, { style: user_style_1.default.gridHeight, dataGrid: dataGrid, columns: actionColumn.concat(user_types_1.userColumnProps), dataStates: dataStates, pageable: true, sortable: true, sort: dataStates.sort, onPageChange: v => onDataStateChange('page', v), onTakeChange: v => onDataStateChange('take', v), onSortChange: onSortChange, onFilterChange: onFilterChange })] }));
};
exports.default = User;
